// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Chain = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M6 4c.744 0 1.45.164 2.084.455a6 6 0 0 0-.749.774 4 4 0 1 0 2.248 1.993c.204-.285.454-.534.74-.732A5 5 0 1 1 6 4m6 0a5 5 0 1 1-2.084 9.545q.409-.354.749-.774a4 4 0 1 0-2.248-1.993 3 3 0 0 1-.74.732A5 5 0 0 1 12 4"
    />
  </svg>
);
const ForwardRef = forwardRef(Chain);
export default ForwardRef;
